// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__g5Uze","errorLogs":"styles_errorLogs__WBlHd"};